export default __webpack_public_path__ + "assets/illustrations/sad_emoji.d894d7f89e51bff89fade90ace4bd0ce.png";